/** @jsxImportSource react */
import type { SVGProps } from 'react';
const EyeOff = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.28 3.22a.75.75 0 0 0-1.06 1.06l1.923 1.924a12.4 12.4 0 0 0-2.763 2.6C1.557 9.874 1 11.036 1 12c0 .765.35 1.642.877 2.478.54.856 1.314 1.749 2.275 2.56C6.073 18.66 8.802 20 12 20c2.075 0 3.952-.565 5.537-1.402l2.183 2.182a.75.75 0 1 0 1.06-1.06l-5.244-5.245zm3.694 5.815-1.75-1.75c-1.11.728-2.012 1.596-2.654 2.432-.754.982-1.07 1.816-1.07 2.283 0 .355.184.944.646 1.678.45.713 1.119 1.492 1.974 2.214C6.83 17.336 9.228 18.5 12 18.5c1.622 0 3.116-.398 4.42-1.02l-1.455-1.454a5 5 0 0 1-6.99-6.991m5.913 5.913a3.5 3.5 0 0 1-4.835-4.835z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12 5.5a10 10 0 0 0-2.524.326.75.75 0 1 1-.379-1.452A11.5 11.5 0 0 1 12 4c3.199 0 5.927 1.341 7.848 2.962.961.811 1.735 1.705 2.275 2.56.526.836.877 1.713.877 2.478 0 .665-.265 1.407-.666 2.123-.41.73-1 1.498-1.733 2.226a.75.75 0 1 1-1.057-1.065c.65-.643 1.149-1.302 1.482-1.895.341-.608.474-1.088.474-1.389 0-.355-.184-.944-.646-1.678-.45-.714-1.119-1.492-1.974-2.214C17.17 6.664 14.772 5.5 12 5.5"
    />
    <path
      fill="currentColor"
      d="M11.25 7.75A.75.75 0 0 1 12 7a5 5 0 0 1 5 5 .75.75 0 0 1-1.5 0A3.5 3.5 0 0 0 12 8.5a.75.75 0 0 1-.75-.75"
    />
  </svg>
);
export default EyeOff;
